import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import slugify from "../lib/slugify"

import Img from "gatsby-image"
import ReadTime from "./ReadTime"

const ResourceThumbnail = ({ title, excerpt, readTime, alt, featureImage }) => {
  const formattedTitle = title[title.type].map(i => i.plain_text).join("")

  return (
    <Container>
      <Link
        to={`/resources/${slugify(formattedTitle)}`}
      >
        <Img
          fixed={featureImage.node.childImageSharp.fixed}
          alt="Feature Image"
          placeholderStyle={{ visibility: "hidden" }}
          style={{ width: "100%", overflow: "visible" }}
          alt={formattedTitle + " Thumbnail Image"}
        />
        <h3>{formattedTitle}</h3>
        <p>{excerpt[excerpt.type].map(i => i.plain_text).join("")}</p>
        <ReadTime>{readTime} min read</ReadTime>
      </Link>
    </Container>
  )
}

const Container = styled.div`
  padding-bottom: 1em;

  img {
    border-radius: 12px;
  }

  h3, p {
    color: var(--white);
    margin-block-start: 0.5rem;
    margin-block-end: 0.5rem;
  }

  p {
    color: var(--light-grey);
  }
`

export default ResourceThumbnail
